import React, { useEffect, useState, useRef, Dispatch, SetStateAction } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ChooseCam from "@mui/icons-material/Camera";

import {
  Box,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Input,
  Autocomplete,
  TextField,
  IconButton,
  List,
  ListItem,
  Divider,
  Chip,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  SelectChangeEvent,
  TextareaAutosize,
  Paper,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Camera as MuiCamera, Height } from "@mui/icons-material";

import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { Tag } from "primereact/tag";

import {
  Button as BootstrapButton,
  Button,
  Card,
  Form,
  Table,
} from "react-bootstrap";

import {
  getCategoryAssetMasterDataList,
  getUsersMasterDataList,
  getCountryAssetMasterDataList,
  getFamilyAssetMasterDataList,
  getProjectByRegionId,
  getRegionByCountryId,
} from "../../api/Services/masterServie";

import {
  updateFaultData,
  uploadFiles,
  createFaultData,
  getPrevFaultByUserIdData,
  getUniqueAssetNamesByFamilyId,
} from "../../api/Services/assetServices";

import { setLoading } from "../../store/CommonSlice";
import { RootState } from "../../store/Reduxstore";

import { CustomMessage, Loader } from "../../const/Spinner";
import { enqueueSnackbar } from "notistack";
import { base64ToFile } from "../../const/const";

import { FILE_DOWNLOAD_PREVIEW, PAGESEND, PAGESTART } from "../../api/endpoint";

import {
  assetType,
  assetFamilyMaster,
  CountryMaster,
  ProjectMaster,
  RegionMaster,
  UserMaster,
} from "../../types/assetTypes";

import { attachments, faultTypes } from "../../types/faultTypes";

import FixedByMultiSelect from "../../Component/FixedByMultiSelect";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import ReusablePrimeReactDialog from "../../Component/Dialog/ReusablePrimeReactDialog";

import Logo from "../../assets/companyLogo.png";

import "react-html5-camera-photo/build/css/index.css";
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import dayjs from "dayjs";







interface FaultData {
    faultId: number;
    assetName: string;
    hourMeter: number;
    fault: string;
    countryName: string;
    date: string;
    attachments: attachments[];
    fixed_user_id: number;
    fixed_user_ids: number[];
    partsUsed: string;
    workCarriedOut: string;
    faultStatus: string;
    categoryId: number;
    categoryName: string;
    hoursSpent: number;
    fixedAttachments: attachments[];
    user_id: number;
       
  }
  

interface EditFaultProps {
  faultData: FaultData ;
  setFaultData: React.Dispatch<React.SetStateAction<faultTypes>>;

  setOpen: (open: boolean) => void;
  setPathname: (pathname: string) => void;
  faultId: number | null; // Allow null
  setFaultId: (id: number) => void;
  selectedValue: string;
  getListOfSelectedProducts: () => void;
}


interface FaultData {
  faultId: number;
  assetName: string;
  hourMeter: number;
  fault: string;
  worksite: string;
  familyAssetId: number;
  familyName: string;
  countryName: string;
  name: string;
  date: string;
  user_id: number;
  currentLocationId: number;
  attachments: attachments[];
  fixedAttachments: attachments[];
  fixed_user_id: number;
  partsUsed: string;
  workCarriedOut: string;
  faultStatus: string;
  fixedUserName: string;
  projectName: string;
  categoryId: number;
  categoryName: string;
  hoursSpent: number;
  fixedDate: string;
}


const EditFault: React.FC<EditFaultProps> = ({
  faultData, setFaultData,
  setOpen,
}) => {
  console.log("Fault data", faultData);

  const [formData, setFormData] = useState<{
    faultId:number;
    user_id: number;
    name: string;
    familyAssetId: number;
    familyName:string
    assetName: string;
    currentLocationId: number;
    countryName: string;
    hourMeter: number;
    fault: string;
    worksite: string;
    date: string;
    fixedDate: string;
    attachments: any[],
    fixedAttachments: any[],
    fixed_user_id: number;
    partsUsed: string;
    workCarriedOut: string;
    faultStatus: string;
    fixedUserName: string;
    regionId: number;
    projectId: number;
    projectName: string;
    regionName: string;
    fixed_user_ids: number[];
    categoryId: number;
    categoryName: string;
    hoursSpent: number;
    

  }>({
    faultId: 0,   
    name: "",
    familyAssetId: 0,
    familyName: "",
    assetName: "",
    currentLocationId: 0,
    countryName: "",
    hourMeter: 0,
    fault: "",
    worksite: "",
    date: "",
    attachments: [],
    regionId: 0,
    projectId: 0,
    projectName: "",   
    regionName: "",
    fixedDate: faultData.fixedDate || "",
    fixed_user_id: faultData.fixed_user_id ?? 0, 
    user_id: faultData.fixed_user_id ?? 0,  // Default to 0 if null/undefined
    partsUsed: faultData.partsUsed || "",         // Default to empty string if null/undefined
    workCarriedOut: faultData.workCarriedOut || "", // Default to empty string if null/undefined
    faultStatus: faultData.faultStatus || "", 
    fixedUserName: faultData.fixedUserName || "",     // Default to empty string if null/undefined
    fixed_user_ids: faultData.fixed_user_ids || [],
    categoryId: faultData.categoryId || 0,  
    categoryName: faultData.categoryName|| "",  
    hoursSpent: faultData.hoursSpent|| 0,  
    fixedAttachments: faultData.fixedAttachments || [],
  }); 
  const userDetails = useSelector((state: RootState) => state.auth)
  const [hourMeterInput, setHourMeterInput] = useState<string>(
  formData.hourMeter?.toString() || ""  
  );
  useEffect(() => {
  console.log("formData updated:", formData);
  }, [formData]);

  const styles: { [key: string]: React.CSSProperties } = {
    heading: {
      textAlign: "left",
      color: "#333",
      marginBottom: "15px",
      fontSize: "18px",
      fontWeight: "bold",
    },
}
  

  const handleChange = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [name, setUser] = useState<
        { label: string; value: number }[]
      >([]);

  const [category, setCategory] = useState<
        { label: string; value: number }[]
      >([]);

  useEffect(() => {
        if (category.length === 0) getCategoriesList  (1,PAGESEND);
      }, [category]);
  
    useEffect(() => {
        if (name.length === 0) getReportersNameList  (1,PAGESEND);
      }, [name]);

       const getCategoriesList = async (page: number, rows: number) => {
          dispatch(setLoading(true));
          console.log("Fetching category...");      
          try {
            const { data, status } = await getCategoryAssetMasterDataList(page, rows, {
              familyAssetId: { value: "", matchMode: "startsWith" }
            });      
            console.log("Asset type response:", data, status);      
            if (status.code === 200 && data?.length > 0) {
              const updatedData = data.map((val) => ({
                value: Number(val.categoryId), // ✅ Convert user_id to number
                 label: val.categoryName ?? "", // Ensure label is always a string
              }));      
              updatedData.unshift({ label: "", value: 0 });
              setCategory(updatedData);
              console.log("Updated category list:", updatedData);   
            }
          } catch (error: any) {
            console.error("Error fetching categories:", error);
            CustomMessage(error?.message, "error", enqueueSnackbar);
          } finally {
            dispatch(setLoading(false));
            console.log("Category fetch completed.");
          }
        };

  const getReportersNameList = async (page: number, rows: number) => {
          dispatch(setLoading(true));
          console.log("Fetching asset types...");      
          try {
            const { data, status } = await getUsersMasterDataList(page, rows, {
              familyAssetId: { value: "", matchMode: "startsWith" }
            });      
            console.log("Asset type response:", data, status);      
            if (status.code === 200 && data?.length > 0) {
              const updatedData = data.map((val) => ({
                value: Number(val.user_id), // ✅ Convert user_id to number
                 label: val.name ?? "", // Ensure label is always a string
              }));      
              updatedData.unshift({ label: "", value: 0 });
              setUser(updatedData);
              console.log("Updated asset type list:", updatedData);   
            }
          } catch (error: any) {
            console.error("Error fetching asset types:", error);
            CustomMessage(error?.message, "error", enqueueSnackbar);
          } finally {
            dispatch(setLoading(false));
            console.log("Asset type fetch completed.");
          }
        };

  const dispatch = useDispatch();

    
  const handleSelectUserNameChange = (
    selectedOptions: { label: string; value: number }[]
  ) => {
    const fixedUserNames = selectedOptions.map(opt => opt.label);
    const fixedUserIds = selectedOptions.map(opt => opt.value);

    const updatedData = {
      ...formData,
      fixedUserNames,
      fixed_user_ids: fixedUserIds,
    };

    setFormData(updatedData);
  };

  const handleSubmit = async (e: any) => {
    e?.preventDefault();  
    const updatedData = { ...formData };
    
    const payload = {
      faultId: faultData?.faultId || 0,
      assetName: faultData?.assetName || '',
      familyName: faultData?.familyName || '',
      familyAssetId: faultData?.familyAssetId || 0,
      countryName: faultData?.countryName || '',
      name: faultData?.name || '',
      currentLocationId: faultData?.currentLocationId || 0,
      hourMeter: faultData?.hourMeter ?? 0,
      fault: faultData?.fault ?? '',  
      worksite: faultData?.worksite || '',
      date: faultData?.date || "",  // Default to current date if null
      user_id: userDetails.userId,
      fixed_user_id: updatedData.fixed_user_id ?? 0,
      fixedDate: updatedData.fixedDate ?? "",    
      fixedUserName: updatedData.fixedUserName || "",  // Default to 0 if undefined
      partsUsed: updatedData.partsUsed || "",         // Default to empty string if undefined
      workCarriedOut: updatedData.workCarriedOut || "", // Default to empty string if undefined
      faultStatus: updatedData.faultStatus || "",
      attachments: faultData?.attachments || [],
      regionId: updatedData.regionId ?? 0,
      projectId: updatedData.projectId ?? 0,
      regionName: updatedData.regionName|| "",
      projectName: updatedData.projectName|| "",
      fixed_user_ids: updatedData.fixed_user_ids || [],
      categoryId: updatedData.categoryId,
      categoryName: updatedData.categoryName,
      hoursSpent: updatedData.hoursSpent,
      fixedAttachments: updatedData.fixedAttachments, 
  };
  
    dispatch(setLoading(true));
  
    try {
      // Always use createFaultData
      const response = await updateFaultData(payload);

      console.log("Response:", response); // Debugging
      console.log("Response Status:", response.status); // Debugging

  
      // Check response status directly if it's a number
      if (response.status.code === 201 || response.status.code === 200) {
        CustomMessage(
                  response.status.message,
                  "success",
                  enqueueSnackbar
          
                );
      setOpen(false);
      } else {
        CustomMessage(response.status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

const handleCategoryChange = (
  e: SelectChangeEvent<any> | string
) => {
  const value = typeof e === "string" ? e : e.target.value;
  const name = typeof e === "string" ? "categoryId" : e.target.name;

  if (name === "categoryId") {
    const selectedCategory = category.find((c) => c.value === Number(value));
    setFormData((prev) => ({
      ...prev,
      categoryId: Number(value),
      categoryName: selectedCategory?.label || "",
    }));
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};

const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
  const fileList = event.target.files;
  if (!fileList || fileList.length === 0) {
    CustomMessage("No file selected", 'error', enqueueSnackbar);
    return;
  }

  const fileArray = Array.from(fileList); // Convert FileList to an array
  dispatch(setLoading(true));

  try {
    const uploadPromises = fileArray.map(async (file) => {
      if (!file) {
        CustomMessage("File not found", 'error', enqueueSnackbar);
        return null;
      }

      const data = new FormData();
      data.append('file', file);

      const response = await uploadFiles(data);
      if (response.status.code === 201) {
        return response.data; // return uploaded file data
      } else {
        CustomMessage(`Upload failed with status: ${response.status.code}`, 'error', enqueueSnackbar);
        throw new Error(`Upload failed with status: ${response.status.code}`);
      }
    });

    // Wait for all uploads to finish
    const uploadedFiles = (await Promise.all(uploadPromises)).filter(Boolean);

    if (uploadedFiles.length > 0) {
      // Append uploaded files to existing attachments
      setFormData((prev) => ({
        ...prev,
        fixedAttachments: [
          ...(prev.fixedAttachments || []),
          ...uploadedFiles,
        ],
      }));

      CustomMessage("Files uploaded successfully", 'success', enqueueSnackbar);
    }
  } catch (error: any) {
    CustomMessage(`File upload error: ${error.message}`, 'error', enqueueSnackbar);
  } finally {
    dispatch(setLoading(false));
  }
};

const commonInputSx = {
  width: "100%",
  height: "40px",
  "& .MuiInputBase-root": {
    height: "40px",
    minHeight: "40px",
    paddingTop: "0px",
    paddingBottom: "0px",
  },
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    height: "40px",
    paddingTop: "0px !important",
    paddingBottom: "0px !important",
  },
};

  const removeFile = (index: number) => {
    const updatedAttachments = [...formData.fixedAttachments];
    updatedAttachments.splice(index, 1);
    setFormData({ ...formData, fixedAttachments: updatedAttachments });
  };
  
  interface TakeCameraProps {
    formData: faultTypes; // Form data structure
    setFormData: React.Dispatch<React.SetStateAction<faultTypes>>; // Function to set form data
}


interface Location {
  latitude: number;
  longitude: number;
}

const TakeCamera: React.FC<TakeCameraProps> = ({ formData, setFormData }) => {
    const [location, setLocation] = useState<Location | null>(null);
    const [imgsrc, setImgSrc] = useState<string|null>(null);
    const [cameraOpen, setCameraOpen] = useState(false);
    const [openCam,setOpenCam] = useState(false)
    const streamRef = useRef<MediaStream | null>(null);

    useEffect(() => {
        getLocation();
    }, []);

    const watermark = new Image();
      watermark.crossOrigin = "anonymous";
      watermark.src = Logo;
      watermark.onload = function () {
          const canvas = document.createElement("canvas"); 
          canvas.width = watermark.width; 
          canvas.height = watermark.height; 
          const ctx = canvas.getContext("2d");
          if(ctx){
            ctx.drawImage(watermark, 0, 0);
          }
          const imgData = canvas?.toDataURL("image/png"); 
      };
      watermark.onerror = function () {
          console.error("Failed to load watermark image.");
      };

    interface CapturePhotoProps {
      dataUri: string;
    }

    const capturePhoto = async ({ dataUri }: CapturePhotoProps): Promise<void> => {
      try {
        const img = new Image();

        const loadImage = new Promise<void>((resolve, reject) => {
          img.onload = () => resolve();
          img.onerror = () => reject(new Error("Failed to load image"));
          img.src = dataUri;
        });

        await loadImage;

        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const context = canvas.getContext("2d");

        if (context) {
          context.drawImage(img, 0, 0);

          const timestamp = new Date().toLocaleString();
          const gpsLocation = `${location?.latitude},${location?.longitude}`;

          context.font = "18px Arial";
          context.fillStyle = "white";
          context.fillText(timestamp, 10, 30);
          context.fillText(gpsLocation, 10, 60);

          const logoWidth = 130; // Adjust the logo size as needed
          const logoHeight = 70;
          const logoX = canvas.width - logoWidth - 25; // Adjust the position as needed
          const logoY = canvas.height - logoHeight - 25;
          context.drawImage(watermark, logoX, logoY, logoWidth, logoHeight);
        }
          const photo = canvas.toDataURL();
          setCameraOpen(false);
          setImgSrc(photo);
      } catch (error:any) {
        CustomMessage(`Error capturing photo:${error?.message}`,"error",enqueueSnackbar)
        console.error("Error capturing photo:", error);
      }
    };

    const handleLocation = (position: GeolocationPosition) => {
        setLocation(position.coords);
    };

    const requestCameraAccess = async (video:boolean) => {
      try {
          const stream = await navigator.mediaDevices.getUserMedia({ video: video });
          // Use the camera stream as needed
          streamRef.current = stream; // Store the stream reference
      } catch (error:any) {
        console.error("Error accessing camera:", error);
        CustomMessage(`Error accessing camera:${error?.message}`,'error',enqueueSnackbar);
        const tracks = streamRef.current?.getTracks() || [];
        tracks.forEach((track) => track.stop());
      }
    };

    const stopCamera = () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop()); // Stop all tracks
        streamRef.current = null; // Clear the reference
      }
      setCameraOpen(false);
      setOpenCam(false);
    };            

    const handleError = (error:any) => {
      // CustomMessage(error?.message,'error',enqueueSnackbar);
        console.error(error);
    };

    const getLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(handleLocation, handleError);
        } else {
          CustomMessage("Geolocation is not supported by this browser",'error',enqueueSnackbar);
            console.error("Geolocation is not supported by this browser");
        }
    };

    const openCamera = async () => {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ video: true })
          .then(() => {
            try{
                  requestCameraAccess(true);
                setCameraOpen(true);
                setOpenCam(true);
                // setImgSrc(null);
            }catch(error){
                console.error("Error opening camera:", error);
                setCameraOpen(false);
                setOpenCam(false);
            }
          })
          .catch((error:any) => {
          // Handle camera access error
            CustomMessage(`Camera access denied:${error?.message}`,'error',enqueueSnackbar);
              console.error('Camera access denied:', error);
          });
      }
    };

    const uploadImage = async () => {
    if (!imgsrc) {
      CustomMessage("Image not generated",'error',enqueueSnackbar);
      return;
    }
    dispatch(setLoading(true));
    try {
      const file = base64ToFile({ base64: imgsrc, filename: 'Photo.png' });
      const data = new FormData();
      data.append('file', file);

      const response = await uploadFiles(data);
      if (response.status.code === 201) {
       setFormData((prev) => ({
        ...prev,
        fixedAttachments: [
          ...(prev.fixedAttachments || []), 
          { ...response.data }            
        ],
      }));

        stopCamera();
      } else {
        CustomMessage(`Upload failed with status: ${response.status.code}`, 'error', enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, 'error', enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
    };


    return (
      <div>
        <ReusablePrimeReactDialog
          header="Take Photo"
          visible={openCam}
          onHide={stopCamera}
          footer={
            <div>
              {!cameraOpen&&
                <>
                  <ReusablePrimeButton severity="secondary" onClick={stopCamera}>Cancel</ReusablePrimeButton>
                  <ReusablePrimeButton severity="info" onClick={uploadImage}>Upload</ReusablePrimeButton>
                </>
              }
            </div>
          }
        >
          {
            cameraOpen ?
                <Camera
                    onTakePhoto={(dataUri: string) => capturePhoto({ dataUri })}
                    idealFacingMode="environment"
                    isFullscreen={false}
                    idealResolution={{ width: 640, height: 480 }}
                    imageType={IMAGE_TYPES.PNG}
                    videoStream={streamRef.current}
                />
            :
            imgsrc && <img src={imgsrc} alt="logo" />
          }
            </ReusablePrimeReactDialog>
            <Box display="flex" flexDirection="column" alignItems="center">   
              <Box
                onClick={openCamera}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  padding: 2,
                  border: "1px dashed gray",
                  borderRadius: "8px",
                  width: "100%",
                  maxWidth: "300px",
                  textAlign: "center",
                  justifyContent: "center",
                  backgroundColor: "#FFFFFF",
                  maxHeight: "45px",  
                }}
              >
                <ChooseCam />
                <span>Take photo</span>
              </Box>            
              {/* <ListItem>
                {formData.fixedAttachments.map((attachment, index) => (
                  <div key={index} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    
                      <Box display="flex" flexDirection="row" gap={1}>
                      </Box>
                  </div>
                  ))}
              </ListItem> */}
            </Box>
      </div>
      );
    };
interface OptionType {
  label: string;
  value: string | number; // or `number` if strictly needed
}

  const statuses = ["Under Repairs", "Repair Completed", "Waiting for Parts"];
  return ( 
    <>
      {faultData ? (
        <>
          <Typography variant="h4" style={styles.heading}>Fault Details</Typography>
          <Box
            sx={{
               mb: 4,
               background: "#fff"
            }}
            component={Paper}
          >

        <Table striped bordered hover responsive>
          <tbody>
            <tr>
              <th>Fault Id</th>
              <th>Asset Name</th>
              <th>Location</th>
              <th>Worksite</th>
              <th>Hour Meter</th>
              <th>Fault Description</th>
              <th>Location</th>
              <th>Date</th>
            </tr>
            <tr>
              <td>{faultData.faultId}</td>
              <td>{faultData.assetName}</td>
              <td>{faultData.countryName}</td>
              <td>{faultData.projectName}</td>
              
              <td>
              {userDetails.role.some((r) => r.roleName === "Admin") ? (
              <TextField
              fullWidth
              type="number"
              value={faultData.hourMeter === 0 ? "" : faultData.hourMeter}  // ✅ show "" instead of 0
              className="bg-white"
              onChange={(e) => {
                const value = e.target.value;

                if (value === "") {
                  setFormData((prev) => ({ ...prev, hourMeter: 0 }));
                  setFaultData((prev) => ({ ...prev, hourMeter: 0 }));
                } else {
                  const parsed = parseInt(value, 10);
                  if (!isNaN(parsed)) {
                    setFormData((prev) => ({ ...prev, hourMeter: parsed }));
                    setFaultData((prev) => ({ ...prev, hourMeter: parsed }));
                  }
                }
              }}
              />
              
              ) : (
                formData.hourMeter
              )}
              </td>

   
              <td>
                {userDetails.role.some((r) => r.roleName === "Admin") ? (
                  <Form.Control
                    as="textarea"
                    rows={2}
                    size="sm"
                    value={faultData.fault}
                    onChange={(e) =>{
                       setFormData((prev) => ({ ...prev, fault: e.target.value }));
                          setFaultData((prev) => ({ ...prev, fault: e.target.value })); 
                        }}
                      />
                ) : (
                  formData.fault
                )}
              </td>
              <td>{faultData.countryName}</td>
              <td>{new Date(faultData.date).toLocaleDateString()}</td>
            </tr>
          </tbody>
        </Table>
      
          </Box>
          <Box sx={{ mb: 4 }}>
            <Typography variant="h4" style={styles.heading}>
              Attachments
            </Typography>

            {faultData.attachments && faultData.attachments.length > 0 ? (
              <Box component="ul" sx={{ pl: 2, mt: 1 }}>
                {faultData.attachments.map((attachment) => (
                  <li key={attachment.attachmentId} style={{ marginBottom: 8 }}>
                    <Typography
                      variant="body2"
                      sx={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                        "&:hover": { color: "darkblue" },
                      }}
                      onClick={() => {
                        const fileUrl = `${FILE_DOWNLOAD_PREVIEW}${attachment.attachmentId}`;
                        const link = document.createElement("a");
                        link.href = fileUrl;
                        link.setAttribute("download", attachment.name || "downloaded-file");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }}
                    >
                      {attachment.name}
                    </Typography>
                  </li>
                ))}
              </Box>
            ) : (
            <Typography variant="body2" color="textSecondary" sx={{ pl: 2, mt: 1 }}>
              No attachments attached.
            </Typography>
            )}
          </Box>
          </>
          ) : (
            <Typography align="center" sx={{ mb: 3 }}>
              Loading fault details...
            </Typography>
          )}
          <Typography variant="h4" style={styles.heading}>
            Fault Management
          </Typography>

          <form
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault(); // 🔒 prevent form submission
              }
            }}
          >

            {/* Form Fields in a Single Responsive Row */}

            <Grid container spacing={2} alignItems="center">
              {/* Fixed By */}
               

              <Grid item xs={12} md={2}>
                <InputLabel><strong>Fault Status</strong></InputLabel>
               <Autocomplete
                options={statuses.map((status) => ({ label: status, value: status }))}
                getOptionLabel={(option) => option.label}
                value={
                statuses.includes(formData.faultStatus)
                  ? { label: formData.faultStatus, value: formData.faultStatus }
                  : null
                }
                onChange={(_, selectedOption) => {
                setFormData((prev) => ({
                  ...prev,
                  faultStatus: selectedOption?.value || "",
                }));
                }}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      
                      variant="outlined"
                      size="small"
                      sx={commonInputSx}
                    />
                  )}
                />

              </Grid>
              <Grid item xs={12} md={2}>
                <InputLabel><strong>Category</strong></InputLabel>
                <Autocomplete
                  options={category}
                  getOptionLabel={(option) => option.label}
                  value={category.find((opt) => opt.value === formData.categoryId) || null}
                  onChange={(_, selectedOption) => {
                    handleCategoryChange(selectedOption ? selectedOption.value.toString() : "0");
                  }}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                    
                      variant="outlined"
                      size="small"
                      sx={commonInputSx}
                    />
                  )}
                  />
              </Grid>
              <Grid item xs={12} md={2}>
                <InputLabel><strong>Hours Spent</strong></InputLabel>
                <TextField
              label=""
              value={formData.hoursSpent || ""}
              onChange={(e) =>
                setFormData({ ...formData, hoursSpent: Number(e.target.value) })
              }
              margin="none"
              type="number"
              sx={commonInputSx}
              />

              </Grid>
                            <Grid item xs={12} md={2}>
                <InputLabel><strong>Fixed By</strong></InputLabel>
                <FixedByMultiSelect
               // label="Fixed By"
                options={name}
                selectedValues={name.filter((opt) => formData.fixed_user_ids?.includes(opt.value))}
               onChange={(selectedOptions: OptionType[]) => {
                const ids = selectedOptions.map((opt) => Number(opt.value)); // Cast to number
                setFormData((prev) => ({
                  ...prev,
                  fixed_user_ids: ids,
                }));
                handleSelectUserNameChange(
                  selectedOptions.map(opt => ({
                    label: opt.label,
                    value: Number(opt.value)
                  }))
                );
              }}

                />


              </Grid>
              <Grid item xs={12} md={2}>
              <InputLabel><strong>Fixed date</strong></InputLabel>
              <Calendar
                id="fixedDate"
                className="w-100 block bg-white h-45"
                value={formData.fixedDate ? new Date(formData.fixedDate) : null}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    fixedDate: e.value ? dayjs(e.value).format("YYYY-MM-DD") : "",
                  })
                }
                showIcon
                dateFormat="mm/dd/yy"
                placeholder="Select Date"
              />
              </Grid>
              <Grid item xs={12} md={2}></Grid>
              
              <Grid item xs={12} md={2}>
              <InputLabel><strong>Parts Used</strong></InputLabel>
              <TextareaAutosize
                minRows={2}
                placeholder="Enter parts used..."
                value={formData.partsUsed || ""}
                onChange={(e) =>
                  setFormData({ ...formData, partsUsed: e.target.value })
                }
                style={{
                  width: "100%",
                  borderRadius: "6px",
                  padding: "10px",
                  fontFamily: "inherit",
                  fontSize: "14px",
                  resize: "vertical",
                }}
              />
              </Grid>
              <Grid item xs={12} md={2}>
              <InputLabel><strong>Work Carried Out</strong></InputLabel>
              <TextareaAutosize
                minRows={2}
                placeholder="Describe work carried out..."
                value={formData.workCarriedOut || ""}
                onChange={(e) =>
                  setFormData({ ...formData, workCarriedOut: e.target.value })
                }
                style={{
                  width: "100%",
                  borderRadius: "6px",
                  padding: "10px",
                  fontFamily: "inherit",
                  fontSize: "14px",
                  resize: "vertical",
                }}
              />
              </Grid>
              <Grid item xs={12} md={2}></Grid>
              <Grid item xs={12} md={2}></Grid>
              <Grid item xs={12} md={2}></Grid>
              <Grid item xs={12} md={2}></Grid>

              {/* Attach File */}


            <Grid item xs={12} md={2}>
            <label style={styles.label}>Take Photo</label>
            <div style={{ border: "0px" }}></div>
              <TakeCamera formData={formData} setFormData={setFormData} />
            </Grid>
             <Grid item xs={12} md={2}>
             <label style={styles.label}>Attach File</label>
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="fileUpload"></InputLabel>
                <Input
                  id="fileUpload"
                  type="file"
                  inputProps={{ multiple: true, accept: ".pdf, .xls, .xlsx" }}
                  onChange={handleFileUpload}
                  className="bg-white m-0 h-45 border border-[#0000003b]"
                />
              </FormControl>
             </Grid>

             
              <Grid item xs={12} md={2}></Grid>
              <Grid item xs={12} md={2}></Grid>
              <Grid item xs={12} md={2}></Grid>
              <Grid item xs={12} md={2}></Grid>            

            {formData?.fixedAttachments?.length > 0 && (
                <Grid item xs={12} sm={6} md={4}>
                  <Box
                    sx={{
                      width: "100%",
                      border: "1px solid #ddd",
                      borderRadius: "5px",
                      p: 1,
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <List sx={{ width: "100%", bgcolor: "background.paper", px: 1 }}>
                      {formData.fixedAttachments.map((file, index) => {
                        const isImage = /\.(jpg|jpeg|png)$/i.test(file.name);

                        // Determine source: File object or already uploaded
                        const src = file instanceof File 
                          ? URL.createObjectURL(file) 
                          : file.url || `${FILE_DOWNLOAD_PREVIEW}${file.attachmentId}`;

                        return (
                          <ListItem
                            key={index}
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              borderBottom: "1px solid #ddd",
                              p: 0,
                              mb: 1,
                            }}
                          >
                            {isImage ? (
                              <img
                                src={src}
                                alt={file.name}
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                  marginRight: "10px",
                                }}
                              />
                            ) : (
                              <Typography
                                variant="body2"
                                sx={{ wordBreak: "break-word", flexGrow: 1 }}
                              >
                                {file.name}
                              </Typography>
                            )}

                            <IconButton
                              onClick={() => {
                                const fileUrl = file instanceof File 
                                  ? src 
                                  : `${FILE_DOWNLOAD_PREVIEW}${file.attachmentId}`;
                                const link = document.createElement("a");
                                link.href = fileUrl;
                                link.setAttribute("download", file.name);
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              }}
                            >
                              <DownloadIcon color="primary" />
                            </IconButton>

                            <IconButton onClick={() => removeFile(index)}>
                              <CloseIcon color="error" />
                            </IconButton>
                          </ListItem>
                        );
                      })}
                    </List>

                  </Box>
                </Grid>
            )}

             
            </Grid>
            <Box sx={{ mt: 4 }}>
              <Grid container spacing={0.5} justifyContent="flex-end">
                <Grid item>
                  <Button
                    variant="secondary"
                    onClick={() => setOpen(false)}                    
                  >
                    Close
                  </Button>
                </Grid>
                {userDetails.role.some(
                    (r) => r.roleName === "Admin" || r.roleName === "Fault Database Write"
                  ) && (
                    <Grid item>
                      <Button
                        variant="primary"
                        color="primary"
                        className="custom-submit-button"
                        onClick={handleSubmit}
                      >
                        Submit
                      </Button>
                    </Grid>
                  )}

              </Grid>
            </Box>
          </form>
    </>    
  );
};  
  export default EditFault;


